"use strict";

/*global  jQuery*/

$(window).on('load',function () { 
  var date = new Date();
  $('.cYear').text(date.getFullYear());
});

jQuery(function ($) {
$(function () {
  //読み込みが完了
  $(window).on('load',function () { 
    console.log('jQuery Page Loaded.');  
  });
  // ページ内スムーズスクロール 
  $(document).on('click', 'a.link-scroll', function (event) {
    var href = $(this).attr("href"),
    target = $(href === "#" || href === "" ? 'html' : href);
    target.velocity("scroll", { duration: 500 });
    // target.velocity("scroll", { duration: 500, offset: -78 });
    return false;
  });

  /*
    --------------------------------------
    スクロール処理
    waypoint
    --------------------------------------
    */
  $('.page-animate').css('opacity',0);
  // fadein
  $(".page-animate.page-fade").waypoint(function () {
    var activePoint = $(this.element);
    activePoint.addClass("animated fadeIn");
  }, { offset: '70%' });
  $(".page-animate.page-fade-in").waypoint(function () {
    var activePoint = $(this.element);
    activePoint.addClass("animated fadeInUp");
  }, { offset: '70%' });
  $(".page-animate.page-fade-inLeft").waypoint(function () {
    var activePoint = $(this.element);
    activePoint.addClass("animated fadeInLeftBig");
  }, { offset: '70%' });
  $(".page-animate.page-fade-inRight").waypoint(function () {
    var activePoint = $(this.element);
    activePoint.addClass("animated fadeInRightBig");
  }, { offset: '70%' });

  // //ページトップ戻るボタン 動作
  // $(document).on("click", "#btn-pagetop", function () {
  //   $('body,html').velocity("scroll", { duration: 500, offset: 250 });
  //   return false;
  // });
  // //ページトップ戻るボタン 表示ギミック
  // $(window).scroll(function () {
  //   $('header').toggleClass('fixed_up', $(this).scrollTop() > 120);
  //   if ($(this).scrollTop() > 100) {
  //     $("#btn-pagetop").fadeIn(300);
  //   } else {
  //     $("#btn-pagetop").fadeOut(300);
  //   }
  // });
});
});

//touchstartに対応してたらtouchstart、してなければclick
let mytap = window.ontouchstart===null?"touchstart":"click";
console.log('touch対応：' + mytap);

// DOM読み込み完了
document.addEventListener('DOMContentLoaded', function(e) {
  console.log('DOM Content Loaded.');

  var menubtn = document.querySelectorAll('.btn-menu')[0];
  var menu = document.querySelectorAll('.site-menu .menu')[0];
  
  var menuParent = document.getElementsByClassName('menu-item-has-children');
  for( var i = 0; i < menuParent.length; i++ ) {
    menuParent[i].insertAdjacentHTML('afterbegin','<div class="toggle-submenu close"></div>');
  }

  // var spmenubtn = document.querySelectorAll('.toggle-submenu');
  var spmenubtn = document.getElementsByClassName('toggle-submenu');
  for (let i = 0; i < spmenubtn.length; i++) {
    // fuga[i]で現在の要素を指定
    spmenubtn[i].addEventListener(mytap, function() {
      spmenubtn[i].classList.toggle('close');
      spmenubtn[i].classList.toggle('open');
    }, false);
  }

  // var scroll = new SmoothScroll('a[href*="#"]',{
  //   // header: '[data-scroll-header]'
  // });

}, false);



// 完全に読み込み完了
window.addEventListener('load', function() {
  console.log('Page Loaded.');
});
